import { useState } from "react";

const faqs = [
  {
    q: "How do I get an expedited passport in Idaho Falls, Idaho?",
    a: "Idaho Falls residents can use Fast Passport Center for 2–9 day expedited processing. Ship your documents overnight and we handle agency submission remotely. The nearest regional agency is in Salt Lake City, about 200 miles south on I-15.",
  },
  {
    q: "Where is the nearest passport agency to Idaho Falls?",
    a: "The Denver Regional Passport Agency (3151 S Vaughn Way, Suite 600, Aurora, CO 80014) is approximately 550 miles southeast of Idaho Falls via I-15 and I-25. It requires an appointment for emergencies only. Fast Passport Center eliminates that trip entirely.",
  },
  {
    q: "What passport acceptance facilities are available in Idaho Falls?",
    a: "Idaho Falls has several acceptance facilities including the Main Post Office on Park Ave, the Bonneville County Clerk's Office on N Capital Ave, the Ammon City Hall, and post offices in Rexburg and Blackfoot. New applicants and minors must visit one of these in person.",
  },
  {
    q: "Can I renew my passport by mail from Idaho Falls?",
    a: "Yes. If you are 16 or older, your passport is less than 15 years old, and it was issued after age 16, you can renew entirely by mail using DS-82. Fast Passport Center handles the whole process — no post office visit needed.",
  },
  {
    q: "How long does a passport take from Idaho Falls?",
    a: "Through Fast Passport Center: 2–9 business days for expedited, 24 hours for life-or-death emergency. Routine post office processing takes 6–11 weeks. Standard post office expedited takes 3–5 weeks.",
  },
  {
    q: "Does Idaho Falls Regional Airport serve international flights?",
    a: "IDA primarily serves domestic connections to hubs like Salt Lake City, Seattle, and Denver. For international travel, you will likely connect through a hub. Ensure your passport is valid with at least 6 months beyond your return date.",
  },
  {
    q: "What if I'm applying for my child's passport in Idaho Falls?",
    a: "Children under 16 require both parents to appear at the acceptance facility, or a parent must provide notarized DS-3053 consent. We guide Idaho Falls families through every parental consent requirement including the Bonneville County Clerk option.",
  },
  {
    q: "I'm traveling to Yellowstone — do I need a passport?",
    a: "Yellowstone itself is domestic and does not require a passport. However, if your plans include any cross-border travel to Canada or Mexico, or international flights during your trip, you will need a valid passport.",
  },
];

export { faqs };

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Questions from Idaho Falls Travelers
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Answers to the most common passport questions from Idaho Falls, Ammon, Rexburg, Pocatello, and the surrounding eastern Idaho area.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left"
              >
                <span className="font-semibold text-[#1A365D] text-sm pr-4">{faq.q}</span>
                <i className={`flex-shrink-0 text-[#1A365D] transition-transform ${open === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
              </button>
              {open === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}